"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from './styles.module.scss';
import { useTheme } from '@/providers/themeProvider';

const DaxkoBrands = () => {
	const { theme } = useTheme();

	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) return null; // Prevent hydration mismatch

	const getImageSrc = (lightSrc, darkSrc) => theme === 'light' ? lightSrc : darkSrc;

	return (
		<div className={`${styles.navBrands} ${theme === "dark" ? styles.dark : styles.light}`}>
			<p className={styles.navBrands__title}>Daxko Family of Brands</p>
			<ul className={styles.navBrands__list}>
				{[
					{
						href: "https://www.clubautomation.com/",
						light: "/new_logos/new_ca_light_bg.png",
						dark: "/new_logos/new_ca_dark_bg.png",
						width: 5523,
						height: 876,
						alt: "Club Automation Logo",
						className: ""
					},
					{
						href: "https://zenplanner.com/",
						light: "/new_logos/new_zp_light_bg.png",
						dark: "/new_logos/new_zp_dark_bg.png",
						width: 4179,
						height: 876,
						alt: "Zen Planner Logo",
						className: ""
					},
					{
						href: "https://reclique.com/",
						light: "/new_logos/new_core_light_bg.png",
						dark: "/new_logos/new_core_dark_bg.png",
						width: 2054,
						height: 876,
						alt: "Daxko Core Logo",
						className: "core"
					},
					{
						href: "https://www.sugarwod.com/",
						light: "/new_logos/new_sw_light_bg.png",
						dark: "/new_logos/new_sw_dark_bg.png",
						width: 3979,
						height: 876,
						alt: "SugarWOD Logo",
						className: ""
					},
					{
						href: "https://www.clubautomation.com/engage-pro/",
						light: "/new_logos/new_ep_light_bg.png",
						dark: "/new_logos/new_ep_dark_bg.png",
						width: 4068,
						height: 876,
						alt: "Engage Pro Logo",
						className: ""
					},
					{
						href: "https://www.motionsoft.net/",
						light: "/new_logos/new_ms_light_bg.png",
						dark: "/new_logos/new_ms_dark_bg.png",
						width: 3979,
						height: 876,
						alt: "Motionsoft Logo",
						className: ""
					}
				].map(({ href, light, dark, width, height, alt, className }, i) => (
					<li key={i} className={`${styles.navBrands__item} ${className}`}>
						<Link href={href} target="_blank">
							<Image
								src={getImageSrc(`${light}`, `${dark}`)}
								width={width}
								height={height}
								alt={alt}
								priority
							/>
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
};

export default DaxkoBrands;
